import * as React from 'react';
import * as PropTypes from 'prop-types';
import { difference, filter, intersectionWith, isEmpty, without } from 'lodash';
import { ReactComponent as CheckIcon } from 'images/check-calc.svg';
import './style.scss';
import Modal from '../Modal';
import Button from '../Button';
import ChecksTableForm from './ChecksTableForm';
import { List } from 'immutable';
import PreviewReceipt from 'modules/Checks/components/PreviewReceipt';

const MODAL_STATE_TABLE = 'TABLE';
const MODAL_STATE_VIEW = 'VIEW';

export default class CalculationCheck extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    checks: PropTypes.array,
    bindingFieldName: PropTypes.string,
    excludedChecksId: PropTypes.array,
    categoryCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    originalField: PropTypes.string,
    initialData: PropTypes.oneOfType([PropTypes.instanceOf(List), PropTypes.array]),
  };

  static defaultProps = {
    excludedChecksId: [],
    bindingFieldName: 'checksCalculation',
  };

  state = { showModal: null };

  handleCalculationClick = () => {
    this.setState({ showModal: MODAL_STATE_TABLE });
  };

  getAvailableChecks = () => {
    const { checks, excludedChecksId, categoryCode } = this.props;
    const initialChecks = this.getInitialData();
    const commonExcludedChecks = !isEmpty(initialChecks)
      ? without(excludedChecksId, ...initialChecks)
      : excludedChecksId;

    if (!excludedChecksId && !categoryCode) {
      return checks;
    }

    return filter(
      checks,
      ({ receiptId, receiptCategory }) =>
        !commonExcludedChecks.includes(receiptId) &&
        receiptCategory &&
        receiptCategory.id === categoryCode,
    );
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleSelectedChecks = (data) => {
    const { onClick } = this.props;

    const initialChecks = this.getInitialData();

    this.handleCloseModal();
    const deletedChecks = difference(initialChecks, data);

    const checkList = this.getAvailableChecks();
    const checkObj = {
      addedChecks: intersectionWith(checkList, data, (listItem, id) => listItem.receiptId === id),
      deletedChecks,
    };
    onClick(checkObj);
  };

  handleViewCheck = (receiptId) => {
    this.setState({ showModal: MODAL_STATE_VIEW, receiptData: { receiptId } });
  };

  getInitialData = () => {
    const { initialData } = this.props;
    if (!initialData) {
      return [];
    }
    return List.isList(initialData) ? initialData.toJS() : initialData;
  };

  render() {
    const availableChecks = this.getAvailableChecks();
    const { bindingFieldName } = this.props;
    const { showModal, receiptData } = this.state;

    if (!availableChecks.length) {
      return null;
    }

    return (
      <div className="ml-2 check-icon-wrapper cursor-pointer">
        <CheckIcon title={'Рассчитать сумму по чекам'} onClick={this.handleCalculationClick} />
        {showModal && (
          <Modal
            type="large"
            showModal={true}
            onClose={this.handleCloseModal}
            id={bindingFieldName}
          >
            {showModal === MODAL_STATE_TABLE && (
              <ChecksTableForm
                loading={false}
                initialData={this.getInitialData()}
                checkList={availableChecks}
                parentName={bindingFieldName}
                onView={this.handleViewCheck}
                onSubmit={this.handleSelectedChecks}
                goBack={this.handleCloseModal}
              />
            )}
            {showModal === MODAL_STATE_VIEW && (
              <>
                <PreviewReceipt record={receiptData} hasDownloadLink={false} />
                <div className="margin_top_20">
                  <Button size={'medium'} type={'button'} onClick={this.handleCalculationClick}>
                    Вернуться
                  </Button>
                </div>
              </>
            )}
          </Modal>
        )}
      </div>
    );
  }
}
